import { Input } from '@/components/ui/input';
import { useState, useEffect } from 'react';
import {  Search } from 'lucide-react';
import VideoCard from './components/VideoCard';
import { useVideos } from '@/hooks/useVideos';
import { useLocation } from 'react-router-dom';

function Videos() { 
  const [search, setSearch] = useState('');
  const location = useLocation();
  const { data: videos, isLoading, error } = useVideos();

  useEffect(() => {
    const hash = location.hash.substring(1);
    if (hash && videos) {
      const topic = videos.find(t => t.slug === hash);
      if (topic) {
        setSearch(topic.title);
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    } else {
      setSearch('');
    }
  }, [location.hash, videos]);


  if (isLoading) {
    return (
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Video instructions</h2>
        <div className="flex items-center justify-center py-8">
          <div className="text-muted-foreground">Loading videos...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">Video instructions</h2>
        <div className="flex items-center justify-center py-8">
          <div className="text-red-500">Error loading videos: {error.message}</div>
        </div>
      </div>
    );
  }

  if (!videos || videos.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Video instructions</h2>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search topics..."
          className="pl-10 w-64"
          value={search}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-4">
        {videos.filter(topic => topic.title.toLowerCase().includes(search.toLowerCase())).map((topic) => (
          <div key={topic.slug} id={topic.slug} className="scroll-mt-20">
            <VideoCard item={topic} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default Videos